export enum OrganisationType {
  Abteilung = 'Abteilung',
  Bereich = 'Bereich',
  Firma = 'Firma',
  Standort = 'Standort',
  Subfirma = 'Subfirma',

  Department = 'Department',
  Area = 'Area',
  Company = 'Company',
  Location = 'Location',
  Subcompany = 'Subcompany'
}
